import { render, staticRenderFns } from "./CoozzyFooter.vue?vue&type=template&id=6a0d3072&scoped=true"
import script from "./CoozzyFooter.vue?vue&type=script&lang=js"
export * from "./CoozzyFooter.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFooter.vue?vue&type=style&index=0&id=6a0d3072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0d3072",
  null
  
)

export default component.exports